import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Auth, Logger } from 'aws-amplify';
import './index.css';
import App from './App';
import RedirectToHostedUI from './auth/RedirectToHostedUI';
import MfaHandler from './auth/MfaHandler';
import * as serviceWorker from './serviceWorker';

const logger = new Logger('index');

// Create a callback handler component
const CallbackHandler = () => {
  const [error, setError] = React.useState(null);
  
  React.useEffect(() => {
    // Process the authentication tokens and store them
    const processAuth = async () => {
      try {
        // Parse the URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        if (code) {
          try {
            logger.debug('Processing auth code from Cognito hosted UI');
            
            // Exchange the authorization code for tokens
            await Auth.currentSession();
            logger.debug('Session obtained successfully');
            
            // Get the user to check if they're an external vendor
            const user = await Auth.currentAuthenticatedUser();
            logger.debug('User authenticated:', user);
            
            const userGroups = user.signInUserSession?.idToken?.payload['cognito:groups'] || [];
            const isExternalVendor = userGroups.includes('external-vendor');
            
            if (isExternalVendor) {
              // Store the email for MFA
              const email = user.signInUserSession?.idToken?.payload?.email;
              if (email) {
                sessionStorage.setItem('userEmail', email);
                logger.debug('Stored user email for MFA:', email);
              }
              
              // Redirect to MFA page
              logger.debug('External vendor detected, redirecting to MFA');
              window.location.href = '/mfa';
            } else {
              // Not an external vendor, redirect to main app
              logger.debug('Not an external vendor, redirecting to main app');
              window.location.href = '/';
            }
          } catch (err) {
            logger.error('Error getting session:', err);
            setError('Error processing authentication');
          }
        } else {
          logger.error('No authorization code found in URL');
          setError('No authorization code found in the URL');
        }
      } catch (error) {
        logger.error('Error processing authentication:', error);
        setError('Error processing authentication');
      }
    };
    
    processAuth();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }
  
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/callback" component={CallbackHandler} />
        <Route path="/login" component={RedirectToHostedUI} />
        <Route path="/mfa" component={MfaHandler} />
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();